import { createActionGroup, emptyProps } from '@ngrx/store';

export const CreditOverviewActions = createActionGroup({
  source: 'Credit Overview',
  events: {
    Enter: emptyProps(),
  },
});
